module.exports = __webpack_public_path__ + "img/selective.5ea824eb.png";